import { IRootState } from '../../../store'
import { IPatientMedicationsState } from '../store/patientMedications.types'

export const getPatientMedicationsSelector = (state: IRootState): IPatientMedicationsState => state.patientMedications
